
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexPub3vLhtbyknb_YiuWqgQrG_459Z3VJ6SqDdHR5tyURxkMeta } from "/srv/app/app/pages/index.vue?macro=true";
import { default as rampageWYazskX7jAucaIWmzZwrhnKXsq5lkSSt6CoNpwRGkmAMeta } from "/srv/app/app/pages/rampage.vue?macro=true";
import { default as terminaldPZd_aZuJRGF8ritjZ3io_45Tiqyz1aSBP_45cwOmC6kBTAMeta } from "/srv/app/app/pages/terminal.vue?macro=true";
import { default as indexCkVPUmDaOCixq78uidmEJOwtU46EOo0N83Ml1Zk44TsMeta } from "/srv/app/app/pages/health/index.vue?macro=true";
import { default as loginVobSG3k69x2K5tz12dCd_453p_bC1jUS82IeNkPBhDdbYMeta } from "/srv/app/layers/self-service/pages/[locale]/login.vue?macro=true";
import { default as sitemapEijSTH4euTqlFyT9VFm_6hg30KUxNdIlRgN21DI29ncMeta } from "/srv/app/app/pages/[locale]/sitemap.vue?macro=true";
import { default as indexqgPlkaIrpiRIs0olUnNpH5pFaTfYkhd8_bADrbnCjpUMeta } from "/srv/app/app/pages/preview/page/index.vue?macro=true";
import { default as indexoKGmbS8z4W7EtmDnHBQY438cyeg56_cMVNlBEcJfkXYMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/data/index.vue?macro=true";
import { default as emailo00No3_jJo5kGhKJWmSqxklCDOgJQbCJM_myQ7lhRLcMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/data/update/email.vue?macro=true";
import { default as phonen81DQ_uGcZfXOZ6q8Ue9quwq_45futVBHdzlVfYukUlDoMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/data/update/phone.vue?macro=true";
import { default as passwordaj1i0tgEcTWEnNap1goi5YzbUYAF36iHyx4OOj0sW_45wMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/data/update/password.vue?macro=true";
import { default as datawJnyTjH8mZYtwHKXJ2ezcx0x7lH6Oh1KcGDHJXJCDVEMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/data.vue?macro=true";
import { default as indexURoZ8GfpD8FmpYo_kE5hDlcjhoqv2qnG06VH2raA0JAMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/index.vue?macro=true";
import { default as creditVhQrUiD613bCDwv9YRG53j0Ls3H4wiugi9Vdj08rb1UMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/credit.vue?macro=true";
import { default as indexj_olym3Z_KlKqy6SCscXK6pXXXm6otb3WeAYvJWwnxgMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/tariff/index.vue?macro=true";
import { default as changeMiww5epGol9w5hzrvbyPHX5_g92g3MtXArfCHIk_45Ds4Meta } from "/srv/app/layers/self-service/pages/[locale]/selfService/tariff/change.vue?macro=true";
import { default as tariffHgBmF2TAOWWJrwK5A2FQwgg8Mtd21DpVeG5VhmxncuwMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/tariff.vue?macro=true";
import { default as indexXLrVTWJp0JwKIsmZUJinf8yhigshCfK9wMtOjqBp5EYMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/payment/index.vue?macro=true";
import { default as updateqca2T8uliLvoXKFcH6VoyEe26tpNMIchNNGwJlPL5tYMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/payment/update.vue?macro=true";
import { default as paymentdD0Y304c3_45uZo3TJ79K0liIvI0Whz2RAo8duR68TTPcMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/payment.vue?macro=true";
import { default as indexhiu_45P8vYRmvluBG_bILTgrWRlRyHTTfM4PzzB0ePvSUMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/contract/index.vue?macro=true";
import { default as cancelmAL7rjYMdNqCit7FGbiBeqCZWErodSd6Mw2FfYSy68IMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/contract/cancel.vue?macro=true";
import { default as contractZj9_yOXDVtc5cSg98Gj2Qcl7fYrmc4uPFMnh9f2nXqMMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService/contract.vue?macro=true";
import { default as selfServiceWMuF7BGaV7c_45Kppv41Y98Gnc_GPR8tr0SgUFxbU40bUMeta } from "/srv/app/layers/self-service/pages/[locale]/selfService.vue?macro=true";
import { default as indexarS_1s_8ewd1jIvM0AKEJVBgCiQrdudmo_45JVfGHWyPcMeta } from "/srv/app/app/pages/cancel-contract/index.vue?macro=true";
import { default as indexfNzU5bnZ0Bh7RAGnRu0Ocd916J9LoBHQmy2Ot50yM5MMeta } from "/srv/app/app/pages/[locale]/[route]/index.vue?macro=true";
import { default as passwort_45reset_45startQ_45m3xh0IZyIHEZmzMXUz6c_45tIrNHXoE8iVXMRfgR_hAMeta } from "/srv/app/layers/self-service/pages/[locale]/passwort-reset-start.vue?macro=true";
import { default as passwort_45reset_45finishw_HZJBmRXdNP57IZGQ0EuwQ3fdIwCorY5dxw4RAsgnoMeta } from "/srv/app/layers/self-service/pages/[locale]/passwort-reset-finish.vue?macro=true";
import { default as indexOGuuVddoqmn3Xz4l9HnU4zpl2PIGVLTWigSzS4xIErEMeta } from "/srv/app/layers/webviews/pages/webviews/[locale]/[route]/index.vue?macro=true";
import { default as indexVDwyF96zv4Jf13fcNy9a0rroJKH5IXHrL5YWm1dkZHoMeta } from "/srv/app/layers/webviews/pages/webviews/legal/[locale]/[route]/index.vue?macro=true";
import { default as barrierefreiheitdGwrbD7yJxlUiPaP2W8uPqR3t_45sANkPAddXv6nWiBOsMeta } from "/srv/app/layers/webviews/pages/webviews/legal/[locale]/barrierefreiheit.vue?macro=true";
import { default as LostAndFoundXfmfezbTVoutNDis4SQ6tIEUUVOgH06q8OY3yjRAZIwMeta } from "#modules/dbc-extend-pages/pages/LostAndFound.vue?macro=true";
import { default as LostAndFoundbIlUNwfWXQe9QOCpKZRDNYlch2s54urIJoQtfmNkGc8Meta } from "/srv/app/modules/dbc-extend-pages/pages/LostAndFound.vue?macro=true";
import { default as GetTheApprvVV0np5l2_TS5bYqH6_jP8YxG6wX_Bmg_u_K2vlC_4Meta } from "/srv/app/modules/dbc-extend-pages/pages/GetTheApp.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/srv/app/app/pages/index.vue")
  },
  {
    name: "rampage",
    path: "/rampage",
    component: () => import("/srv/app/app/pages/rampage.vue")
  },
  {
    name: "terminal",
    path: "/terminal",
    component: () => import("/srv/app/app/pages/terminal.vue")
  },
  {
    name: "health",
    path: "/health",
    component: () => import("/srv/app/app/pages/health/index.vue")
  },
  {
    name: "locale-login",
    path: "/:locale()/login",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/login.vue")
  },
  {
    name: "locale-sitemap",
    path: "/:locale()/sitemap",
    component: () => import("/srv/app/app/pages/[locale]/sitemap.vue")
  },
  {
    name: "preview-page",
    path: "/preview/page",
    component: () => import("/srv/app/app/pages/preview/page/index.vue")
  },
  {
    name: selfServiceWMuF7BGaV7c_45Kppv41Y98Gnc_GPR8tr0SgUFxbU40bUMeta?.name,
    path: "/:locale()/selfService",
    meta: {"middleware":["auth"]},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService.vue"),
    children: [
  {
    name: datawJnyTjH8mZYtwHKXJ2ezcx0x7lH6Oh1KcGDHJXJCDVEMeta?.name,
    path: "data",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data.vue"),
    children: [
  {
    name: "locale-selfService-data",
    path: "",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/index.vue")
  },
  {
    name: "locale-selfService-data-update-email",
    path: "update/email",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/email.vue")
  },
  {
    name: "locale-selfService-data-update-phone",
    path: "update/phone",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/phone.vue")
  },
  {
    name: "locale-selfService-data-update-password",
    path: "update/password",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/password.vue")
  }
]
  },
  {
    name: "locale-selfService",
    path: "",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/index.vue")
  },
  {
    name: "locale-selfService-credit",
    path: "credit",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/credit.vue")
  },
  {
    name: tariffHgBmF2TAOWWJrwK5A2FQwgg8Mtd21DpVeG5VhmxncuwMeta?.name,
    path: "tariff",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff.vue"),
    children: [
  {
    name: "locale-selfService-tariff",
    path: "",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff/index.vue")
  },
  {
    name: "locale-selfService-tariff-change",
    path: "change",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff/change.vue")
  }
]
  },
  {
    name: paymentdD0Y304c3_45uZo3TJ79K0liIvI0Whz2RAo8duR68TTPcMeta?.name,
    path: "payment",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment.vue"),
    children: [
  {
    name: "locale-selfService-payment",
    path: "",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/index.vue")
  },
  {
    name: "locale-selfService-payment-update",
    path: "update",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/update.vue")
  }
]
  },
  {
    name: contractZj9_yOXDVtc5cSg98Gj2Qcl7fYrmc4uPFMnh9f2nXqMMeta?.name,
    path: "contract",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract.vue"),
    children: [
  {
    name: "locale-selfService-contract",
    path: "",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract/index.vue")
  },
  {
    name: "locale-selfService-contract-cancel",
    path: "cancel",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract/cancel.vue")
  }
]
  }
]
  },
  {
    name: "cancel-contract",
    path: "/cancel-contract",
    component: () => import("/srv/app/app/pages/cancel-contract/index.vue")
  },
  {
    name: "locale-route",
    path: "/:locale()/:route()",
    component: () => import("/srv/app/app/pages/[locale]/[route]/index.vue")
  },
  {
    name: "locale-passwort-reset-start",
    path: "/:locale()/passwort-reset-start",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/passwort-reset-start.vue")
  },
  {
    name: "locale-passwort-reset-finish",
    path: "/:locale()/passwort-reset-finish",
    component: () => import("/srv/app/layers/self-service/pages/[locale]/passwort-reset-finish.vue")
  },
  {
    name: "webviews-locale-route",
    path: "/webviews/:locale()/:route()",
    component: () => import("/srv/app/layers/webviews/pages/webviews/[locale]/[route]/index.vue")
  },
  {
    name: "webviews-legal-locale-route",
    path: "/webviews/legal/:locale()/:route()",
    component: () => import("/srv/app/layers/webviews/pages/webviews/legal/[locale]/[route]/index.vue")
  },
  {
    name: "webviews-legal-locale-barrierefreiheit",
    path: "/webviews/legal/:locale()/barrierefreiheit",
    component: () => import("/srv/app/layers/webviews/pages/webviews/legal/[locale]/barrierefreiheit.vue")
  },
  {
    name: "de-anmelden",
    path: "/de/anmelden",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/login.vue")
  },
  {
    name: "en-login",
    path: "/en/login",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/login.vue")
  },
  {
    name: "de-passwort-vergessen",
    path: "/de/passwort-vergessen",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/passwort-reset-start.vue")
  },
  {
    name: "en-forgot-password",
    path: "/en/forgot-password",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/passwort-reset-start.vue")
  },
  {
    name: "de-passwort-setzen",
    path: "/de/passwort-setzen",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/passwort-reset-finish.vue")
  },
  {
    name: "en-password-reset",
    path: "/en/password-reset",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/passwort-reset-finish.vue")
  },
  {
    name: selfServiceWMuF7BGaV7c_45Kppv41Y98Gnc_GPR8tr0SgUFxbU40bUMeta?.name,
    path: "/de/kundenbereich",
    meta: {"embedded":false,"middleware":["auth"]},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService.vue"),
    children: [
  {
    name: "de-kundenbereich",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/index.vue")
  },
  {
    name: "de-kundenbereich-guthaben",
    path: "guthaben",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/credit.vue")
  },
  {
    name: paymentdD0Y304c3_45uZo3TJ79K0liIvI0Whz2RAo8duR68TTPcMeta?.name,
    path: "zahlungsmittel",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment.vue"),
    children: [
  {
    name: "de-kundenbereich-zahlungsmittel",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/index.vue")
  },
  {
    name: "de-kundenbereich-zahlungsmittel-aendern",
    path: "aendern",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/update.vue")
  }
]
  },
  {
    name: datawJnyTjH8mZYtwHKXJ2ezcx0x7lH6Oh1KcGDHJXJCDVEMeta?.name,
    path: "daten",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data.vue"),
    children: [
  {
    name: "de-daten",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/index.vue")
  },
  {
    name: "de-daten-aendern-email",
    path: "email/aendern",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/email.vue")
  },
  {
    name: "de-daten-aendern-passwort",
    path: "passwort/aendern",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/password.vue")
  },
  {
    name: "de-data-aendern-telefonnummer",
    path: "telefonnummer/aendern",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/phone.vue")
  }
]
  },
  {
    name: tariffHgBmF2TAOWWJrwK5A2FQwgg8Mtd21DpVeG5VhmxncuwMeta?.name,
    path: "tarif",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff.vue"),
    children: [
  {
    name: "de-kundenbereich-tarif-wechseln",
    path: "wechseln",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff/change.vue")
  },
  {
    name: "de-kundenbereich-tarif",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff/index.vue")
  }
]
  },
  {
    name: contractZj9_yOXDVtc5cSg98Gj2Qcl7fYrmc4uPFMnh9f2nXqMMeta?.name,
    path: "vertrag",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract.vue"),
    children: [
  {
    name: "de-kundenbereich-vertrag-kuendigen",
    path: "kuendigen",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract/cancel.vue")
  },
  {
    name: "de-kundenbereich-vertrag",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract/index.vue")
  }
]
  }
]
  },
  {
    name: selfServiceWMuF7BGaV7c_45Kppv41Y98Gnc_GPR8tr0SgUFxbU40bUMeta?.name,
    path: "/en/self-service",
    meta: {"embedded":false,"middleware":["auth"]},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService.vue"),
    children: [
  {
    name: "en-self-service",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/index.vue")
  },
  {
    name: "en-self-service-balance",
    path: "balance",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/credit.vue")
  },
  {
    name: paymentdD0Y304c3_45uZo3TJ79K0liIvI0Whz2RAo8duR68TTPcMeta?.name,
    path: "payment",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment.vue"),
    children: [
  {
    name: "en-self-service-payment",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/index.vue")
  },
  {
    name: "en-self-service-payment-update",
    path: "update",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/update.vue")
  }
]
  },
  {
    name: datawJnyTjH8mZYtwHKXJ2ezcx0x7lH6Oh1KcGDHJXJCDVEMeta?.name,
    path: "data",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data.vue"),
    children: [
  {
    name: "en-data",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/index.vue")
  },
  {
    name: "en-data-update-email",
    path: "update/email",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/email.vue")
  },
  {
    name: "en-data-update-password",
    path: "update/password",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/password.vue")
  },
  {
    name: "en-data-update-phone",
    path: "update/phone",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/phone.vue")
  }
]
  },
  {
    name: tariffHgBmF2TAOWWJrwK5A2FQwgg8Mtd21DpVeG5VhmxncuwMeta?.name,
    path: "tariff",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff.vue"),
    children: [
  {
    name: "en-self-service-tariff-change",
    path: "change",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff/change.vue")
  },
  {
    name: "en-self-service-tariff",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/tariff/index.vue")
  }
]
  },
  {
    name: contractZj9_yOXDVtc5cSg98Gj2Qcl7fYrmc4uPFMnh9f2nXqMMeta?.name,
    path: "contract",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract.vue"),
    children: [
  {
    name: "en-self-service-contract-cancel",
    path: "cancel",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract/cancel.vue")
  },
  {
    name: "en-self-service-contract",
    path: "",
    meta: {"embedded":false},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/contract/index.vue")
  }
]
  }
]
  },
  {
    name: "embedded-de-anmelden",
    path: "/de/embedded-anmelden",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/login.vue")
  },
  {
    name: "embedded-en-login",
    path: "/en/embedded-login",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/login.vue")
  },
  {
    name: selfServiceWMuF7BGaV7c_45Kppv41Y98Gnc_GPR8tr0SgUFxbU40bUMeta?.name,
    path: "/de/embedded-kundenbereich",
    meta: {"embedded":true,"middleware":["auth"]},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService.vue"),
    children: [
  {
    name: "embedded-de-kundenbereich",
    path: "",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/index.vue")
  },
  {
    name: paymentdD0Y304c3_45uZo3TJ79K0liIvI0Whz2RAo8duR68TTPcMeta?.name,
    path: "zahlungsmittel",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment.vue"),
    children: [
  {
    name: "embedded-de-kundenbereich-zahlungsmittel",
    path: "",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/index.vue")
  },
  {
    name: "embedded-de-kundenbereich-zahlungsmittel-aendern",
    path: "aendern",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/update.vue")
  }
]
  },
  {
    name: datawJnyTjH8mZYtwHKXJ2ezcx0x7lH6Oh1KcGDHJXJCDVEMeta?.name,
    path: "daten",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data.vue"),
    children: [
  {
    name: "embedded-de-daten",
    path: "",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/index.vue")
  },
  {
    name: "embedded-de-daten-aendern-email",
    path: "email/aendern",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/email.vue")
  },
  {
    name: "embedded-de-daten-aendern-passwort",
    path: "passwort/aendern",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/password.vue")
  },
  {
    name: "embedded-de-data-aendern-telefonnummer",
    path: "telefonnummer/aendern",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/phone.vue")
  }
]
  }
]
  },
  {
    name: selfServiceWMuF7BGaV7c_45Kppv41Y98Gnc_GPR8tr0SgUFxbU40bUMeta?.name,
    path: "/en/embedded-self-service",
    meta: {"embedded":true,"middleware":["auth"]},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService.vue"),
    children: [
  {
    name: "embedded-en-self-service",
    path: "",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/index.vue")
  },
  {
    name: paymentdD0Y304c3_45uZo3TJ79K0liIvI0Whz2RAo8duR68TTPcMeta?.name,
    path: "payment",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment.vue"),
    children: [
  {
    name: "embedded-en-self-service-payment",
    path: "",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/index.vue")
  },
  {
    name: "embedded-en-self-service-payment-update",
    path: "update",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/payment/update.vue")
  }
]
  },
  {
    name: datawJnyTjH8mZYtwHKXJ2ezcx0x7lH6Oh1KcGDHJXJCDVEMeta?.name,
    path: "data",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data.vue"),
    children: [
  {
    name: "embedded-en-data",
    path: "",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/index.vue")
  },
  {
    name: "embedded-en-data-update-email",
    path: "update/email",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/email.vue")
  },
  {
    name: "embedded-en-data-update-password",
    path: "update/password",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/password.vue")
  },
  {
    name: "embedded-en-data-update-phone",
    path: "update/phone",
    meta: {"embedded":true},
    component: () => import("/srv/app/layers/self-service/pages/[locale]/selfService/data/update/phone.vue")
  }
]
  }
]
  },
  {
    name: "wv-melden",
    path: "/webviews/de/melden",
    component: () => import("#modules/dbc-extend-pages/pages/LostAndFound.vue")
  },
  {
    name: "wv-report",
    path: "/webviews/en/report",
    component: () => import("#modules/dbc-extend-pages/pages/LostAndFound.vue")
  },
  {
    name: "Verloren und gefunden",
    path: "/de/rad-melden",
    meta: {"localizations":[{"id":0,"title":"Lost and found","path":"rad-melden","locale":"de"},{"id":1,"title":"Lost and found","path":"report-a-bike","locale":"en"}]},
    component: () => import("/srv/app/modules/dbc-extend-pages/pages/LostAndFound.vue")
  },
  {
    name: "Lost and found",
    path: "/en/report-a-bike",
    meta: {"localizations":[{"id":0,"title":"Lost and found","path":"rad-melden","locale":"de"},{"id":1,"title":"Lost and found","path":"report-a-bike","locale":"en"}]},
    component: () => import("/srv/app/modules/dbc-extend-pages/pages/LostAndFound.vue")
  },
  {
    name: "Get the App",
    path: "/de/get-the-app",
    meta: {"localizations":[{"id":0,"title":"Get the App","path":"get-the-app","locale":"de"},{"id":1,"title":"Get the App","path":"get-the-app","locale":"en"}]},
    component: () => import("/srv/app/modules/dbc-extend-pages/pages/GetTheApp.vue")
  },
  {
    name: "Get the App",
    path: "/en/get-the-app",
    meta: {"localizations":[{"id":0,"title":"Get the App","path":"get-the-app","locale":"de"},{"id":1,"title":"Get the App","path":"get-the-app","locale":"en"}]},
    component: () => import("/srv/app/modules/dbc-extend-pages/pages/GetTheApp.vue")
  }
]